import { useContext, useState } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import axios from "axios";
import { FiEye, FiEyeOff } from "react-icons/fi";

import { UserContext } from "../../context/user.context";
import { createAppTheme, tokens } from "../../theme";

const theme = createAppTheme("light");

const LoginPage = () => {
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [show, setShow] = useState(false);
  const { login } = useContext(UserContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    const json = Object.fromEntries(new FormData(e.currentTarget));
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API}/user/sign-in`, json, {
        timeout: 60000,
      });
      login(data.user, data.jwt);
      window.location.href = "/";
    } catch (err) {
      if (!err.response) setError("Serverga ulanib bo'lmadi. Internetni tekshiring.");
      else if (err.response.status === 401 || err.response.status === 404)
        setError("Login yoki parol noto'g'ri.");
      else setError(err.response.data?.message || "Kirib bo'lmadi.");
      setBusy(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: "100vh",
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          bgcolor: "background.default",
        }}
      >
        {/* Chap tomon: to'q maydon, belgidagi firuza rangdan yumshoq yorug'lik. */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            justifyContent: "space-between",
            p: 6,
            bgcolor: tokens.ink,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            aria-hidden
            sx={{
              position: "absolute",
              width: 520,
              height: 520,
              right: -160,
              top: -120,
              borderRadius: "50%",
              background: `radial-gradient(circle, ${tokens.brand}33 0%, transparent 68%)`,
            }}
          />
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, position: "relative" }}>
            <Box
              component="img"
              src="/assets/mark.png"
              alt=""
              sx={{ width: 34, height: 34, objectFit: "contain" }}
            />
            <Typography
              sx={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: 18, color: "#FFF" }}
            >
              Alight CRM
            </Typography>
          </Box>

          <Box sx={{ position: "relative", maxWidth: 460 }}>
            <Typography
              sx={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontWeight: 700,
                fontSize: 40,
                lineHeight: 1.12,
                color: "#FFF",
                letterSpacing: "-0.02em",
              }}
            >
              Qayerda nechta bor,
              <br />
              qancha turadi.
            </Typography>
            <Typography sx={{ mt: 2, color: "#8F97C0", fontSize: 15, lineHeight: 1.6 }}>
              Tovarlar, narxlar va omborlardagi qoldiq 1C dan har soatda yangilanadi.
            </Typography>
          </Box>

          <Typography sx={{ position: "relative", color: "#565E8A", fontSize: 12 }}>
            Alight Group
          </Typography>
        </Box>

        {/* O'ng tomon: kirish */}
        <Box sx={{ display: "grid", placeItems: "center", p: { xs: 3, md: 6 } }}>
          <Paper
            component="form"
            onSubmit={handleSubmit}
            sx={{ p: { xs: 3, md: 4.5 }, width: "100%", maxWidth: 400 }}
          >
            <Typography variant="h2" sx={{ mb: 0.5 }}>
              Kirish
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Hisobingiz ma'lumotlarini kiriting.
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <TextField
              label="Login"
              name="username"
              fullWidth
              autoFocus
              autoComplete="username"
              sx={{ mb: 2 }}
            />
            <TextField
              label="Parol"
              name="password"
              type={show ? "text" : "password"}
              fullWidth
              autoComplete="current-password"
              sx={{ mb: 3 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => setShow(!show)}
                      aria-label={show ? "Parolni yashirish" : "Parolni ko'rsatish"}
                    >
                      {show ? <FiEyeOff /> : <FiEye />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              size="large"
              disabled={busy}
              startIcon={busy ? <CircularProgress size={16} color="inherit" /> : null}
            >
              {busy ? "Tekshirilmoqda" : "Kirish"}
            </Button>
          </Paper>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default LoginPage;
